import type { StepName } from './types'

export type FieldsForStep = Readonly<Record<StepName, ReadonlyArray<string>>>

export const fieldsForStep: FieldsForStep = {
  accountLookup: ['ownerNumber', 'registerAsCompany', 'firstName', 'lastName', 'companyName', 'verificationMethod', 'phoneCountry', 'phone', 'contractNumber', 'suffix'],
  mfaVerifyCode: ['verificationCode'],
  userDetails: ['email', 'userName'],
  checkEmail: [],
  setPassword: ['password'],
  mfaSetupSelector: ['mfaMethod', 'phone'],
  mfaSetupDetails: ['phone', 'phoneCountry'],
  accountLockScreen: [],
  mfaCriticalLockScreen: [],
  activationError: [],
}

export const enableRegisterAsCompany: Record<string, boolean> = {
  ebac: false,
  default: true,
}
